<template>
  <div :dir="isHebrew ? 'rtl' : 'ltr'">
    <VoucherViewerModal
      :vouchers="voucherModal.vouchers"
      :visible="voucherModal.visible"
      @close="voucherModal.visible = false"
    />
    <div v-if="allRide.ride" class="btn-toolbar" >
      <div
        ref="floatingRoot"
        class="add-new-activity-add-icon-sticky"
        :style="floatingStyle"> 
        <div 
          v-if="showCreateNewFromSearchNav"
          class="centering"
          >
          <b-btn
            pill
            variant="warning"
            class="single-ride-add-activity-btn single-ride-add-activity-btn_colors centering-with-start"
            @click="goToNewAttraction(serchDayIndex)"
          >
          <div class="add-new-activity-add-icon">
            <p>+</p>
          </div>
          <div class="add-new-activity-add-icon-text">
            {{ t('createNewActivity') }}
          </div>
          </b-btn>
        </div>
      </div>
    </div>
    <div
      v-if="isUserManager && compareToUserId(allRide.ride.authorId) || isSubdomain"
      class="trip-activity-top"
    >
      <h4>{{ t('activitiesAvailableToAdd') }}</h4>
      <div v-if="userIsRideManagerOfThisRide" class="attractions-list-toggle">
        <button
          type="button"
          class="toggle-option"
          :class="{ active: managerAttractionPresenceFilter === 'exclude_existing' }"
          @click="changeManagerListMode('exclude_existing')"
        >
          {{ t('newRideAttractions') }}
        </button>
        <button
          type="button"
          class="toggle-option"
          :class="{ active: managerAttractionPresenceFilter === 'only_existing' }"
          @click="changeManagerListMode('only_existing')"
        >
          {{ t('alreadyInThisRide') }}
        </button>
      </div>
    </div>
    <div 
      v-else
      class="trip-activity-top"
    >
      <h4 v-if="serchAttractiosSorce=='google'">{{ t('googleResults') }}</h4>
      <h4 v-if="serchAttractiosSorce=='internal'">{{ t('internalResultsFromFamilies') }}</h4>
    </div>
    <div class="daily-ride-list">
      <div
        v-if="serchAttractios && serchAttractios.length === 0"
        class="no-attractions-text"
      >
        <p v-if="userIsRideManagerOfThisRide && managerAttractionPresenceFilter === 'only_existing'">
          {{ t('noAttractionsAlreadyInThisRide') }}
        </p>
        <p v-else>
          {{ t('noAttractionsFound') }}
        </p>
      </div>
      <div
        v-for="(attraction, index ) in serchAttractios"
        :key="index"
      >
        <div :id="'serch_attractions_index_' + index" >
          <div class="trip-card-wrap">
            <div class="trip-card-header">
              <h4>{{attraction.title}}</h4>
              <div style="position: relative" class="single_ride_star-location">
                <star-rating 
                  v-if="attraction.rate && !isSubdomain"
                  class="star-custom-text"
                  :read-only="true"
                  :rtl="isHebrew"
                  :increment="0.01"
                  :star-size="15"
                  :rating="attraction.rate"
                  />
              </div>
            </div>
            <div class="trip-card-body">
              <div class="trip-card-content">
                <CollapseText 
                  v-if="attraction.text"
                  class="attraction_information"
                  :text="attraction.text"
                  :uniqueId="Math.random()"
                />
                <!-- Video, Audio media section (internal attractions only) -->
                <div
                  v-if="serchAttractiosSorce=='internal' && (attraction.videoUrl || attraction.audioUrl)"
                  class="serch-attraction-media-section"
                >
                  <div v-if="attraction.videoUrl" class="serch-attraction-media-item">
                    <p class="serch-attraction-media-label mb-1">{{ t('video') }}</p>
                    <video
                      controls
                      preload="none"
                      class="serch-attraction-media-video"
                      :src="attraction.videoUrl"
                      poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 180'%3E%3Crect fill='%23ddd' width='320' height='180'/%3E%3Cpolygon fill='%23999' points='130,70 130,110 160,90'/%3E%3C/svg%3E"
                    >
                      {{ t('videoTagNotSupported') }}
                    </video>
                  </div>
                  <div v-if="attraction.audioUrl" class="serch-attraction-media-item">
                    <p class="serch-attraction-media-label mb-1">{{ t('audio') }}</p>
                    <audio
                      controls
                      class="serch-attraction-media-audio"
                      :src="attraction.audioUrl"
                    >
                      {{ t('audioTagNotSupported') }}
                    </audio>
                  </div>
                </div>
                  <div class="trip-card-footer">
                    <a
                      v-if="rideType=='public' ||
                            ( isUserManager && compareToUserId(allRide.ride.authorId)) ||
                            ( isSubdomain && isIdIsThisDomainRideManager( allRide.ride.ride_manager_id ))"
                      class="trip-card-btn"
                      @click="addAttractionToRideInternal( attraction )"
                      >
                      {{ t('addAttraction') }}
                    </a>
                    <a
                      class="trip-card-btn" 
                      v-if="serchAttractiosSorce=='google'"
                      @click="lowedAttractionAndShow( { 'attractionId': attraction.place_id,
                                                        'sorce':'google' } )"
                    >
                      {{ t('moreDetails') }}
                    </a>
                    <a
                      class="trip-card-btn" 
                      v-else-if="serchAttractiosSorce=='internal'"
                      @click="lowedAttractionAndShow( { 'attractionId': attraction.id,
                                                        'sorce':'internal' } )"
                      >
                      {{ t('moreDetails') }}
                    </a>
                    <a 
                      class="trip-card-btn"
                      v-if="attraction.link"
                      @click="goTo( attraction.link )">
                      {{ t('website') }}
                    </a>
                    <a 
                      class="share-icon"
                      v-if="serchAttractiosSorce=='internal' && rideType=='public'"
                      @click="shareThisAttraction( allRide.ride.id , attraction.id )">
                      <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2FshareAttraction.svg?alt=media&token=a14011d2-1a93-448f-be7a-47d16071465f"
                        alt="">
                    </a>
                  </div>
                  <div
                    v-if="serchAttractiosSorce=='internal' && attraction.voucherUrls && attraction.voucherUrls.length"
                    class="trip-card-footer trip-card-footer-voucher"
                  >
                    <a
                      class="trip-card-btn trip-card-btn-voucher"
                      @click="openVoucherModal(attraction.voucherUrls)"
                    >
                      <span class="material-icons" style="font-size: 16px; vertical-align: middle;">receipt_long</span>
                      {{ attraction.voucherUrls.length > 1 ? t('voucherPlural') : t('voucher') }}
                    </a>
                  </div>
              </div>
              <div class="trip-card-thumb-wrap">
                <div class="trip-card-thumb">
                <img
                  v-if="attraction.image"
                  :src="attraction.image"
                  alt="Image"
                  >
                </div>
                <div class="trip-card-thumb-data">
                    <p
                  v-if="attraction.imageHtmlAttributions"
                  v-html="getImageHtmlAttributions( attraction.imageHtmlAttributions[0])">
                </p>
                  </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CollapseText from "@/components/CollapseText";
import StarRating from 'vue-star-rating';
import VoucherViewerModal from '@/components/VoucherViewerModal.vue';
import { translationMixin } from "@/mixins/translationMixin";
import {
  getFloatingItemStyle,
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
} from "@/services/floatingItems";

export default {
  components: {
    CollapseText,
    StarRating,
    VoucherViewerModal,
  },
  mixins: [translationMixin],

  name: 'SerchAttractions',
  data() {
    return {
      floatingId: "floating-serch-attractions-add",
      voucherModal: { visible: false, vouchers: [] },
    };
  },
  computed:{  ...mapGetters([  'serchAttractios',
                          'isAppLoggedIn',
                          'allRide',
                          'serchDayIndex',
                          'plannedDate',
                          'compareToUserId',
                          'serchAttractiosSorce',
                          'searchAttractionsFilters',
                          'rideType',
                          'isUserManager',
                           ]),
              ...mapGetters("theme",  [ "isIdIsThisDomainRideManager",
                                        "isSubdomain",
                            ]),
            userIsRideManagerOfThisRide(){
              const rideManagerId = this.allRide?.ride?.ride_manager_id;
              return this.isUserManager &&
                     typeof rideManagerId === 'number' &&
                     this.compareToUserId(rideManagerId);
            },
            managerAttractionPresenceFilter() {
              return this.searchAttractionsFilters.rideAttractionPresence || 'exclude_existing';
            },
            showCreateNewFromSearchNav() {
              if (!this.allRide || !this.allRide.ride || this.isSubdomain) {
                return false;
              }
              const ride = this.allRide.ride;
              if (ride.ride_manager_id != null) {
                if (this.compareToUserId(ride.ride_manager_id)) {
                  return true;
                }
                return false;
              }
              if (this.compareToUserId(ride.authorId)) {
                return true;
              }
              return false;
            },
            shouldShowFloatingButton() {
              return this.showCreateNewFromSearchNav;
            },
            floatingStyle() {
              return getFloatingItemStyle(this.floatingId, {
                top: "auto",
                transform: "none",
              });
            },
  },

  methods: {...mapActions([ 'fetchSerchAttractionsByRide',
                            'addAttractionToRide',
                            'viewAttraction',
                            'fetchSerchAttractionsFromRideMangerAcount',
                            'validateAndupdateAppToken',
                            'ReturnToSingleRide',
                            'openLoginForm',
                            'addRideToUser',
                            'goToNewAttraction',
                            'lowedAttractionAndShow',
                            'uplowedGoogleAtractionIfEmpty',
                            'showModalWithParameters',
                            'updateSearchAttractionsFilters',
                            ]),
    goTo( link ){
      window.open(link)
      return 
    },
    shareThisAttraction( rideId, attractionId ){
      this.showModalWithParameters( { inerModalParameters : {rideId:rideId, attractionId:attractionId},
                                      type:'shareAttraction' } );      
    },
    addAttractionToRideInternal( attraction ){
      var id;
      var shouldCopyTheAttraction = false;
      if ( this.serchAttractiosSorce == 'internal'){
        id = attraction.id
        if( this.rideType=='private' && this.isUserManager && this.compareToUserId( this.allRide.ride.authorId ) ){
          shouldCopyTheAttraction = true;
        }
      }
      else if ( this.serchAttractiosSorce == 'google'){
        id = attraction.place_id
      } 
      this.addAttractionToRide( { 'attractionId': id,
                                  'sorce': this.serchAttractiosSorce,
                                  'shouldCopyTheAttraction': shouldCopyTheAttraction,
                                  'image': attraction.image } );
    },
    getImageHtmlAttributions( htmlCode ){
      return htmlCode.slice(0,3) + 'target="_blank"' + htmlCode.slice(3)
    },

    openVoucherLink(voucherUrl) {
      if (voucherUrl) {
        window.open(voucherUrl, '_blank');
      }
    },
    openVoucherModal(vouchers) {
      this.voucherModal = { visible: true, vouchers };
    },
    changeManagerListMode(listMode) {
      if (!this.userIsRideManagerOfThisRide || this.managerAttractionPresenceFilter === listMode) {
        return;
      }
      const filters = { rideAttractionPresence: listMode };
      this.updateSearchAttractionsFilters(filters);
      this.fetchSerchAttractionsFromRideMangerAcount({ filters });
    },
    syncFloatingState() {
      this.$nextTick(() => {
        const root = this.$refs.floatingRoot;
        updateFloatingItem(this.floatingId, {
          visible: !!this.shouldShowFloatingButton,
          height: this.shouldShowFloatingButton && root ? root.offsetHeight : 0,
        });
      });
    }
  },
  watch: {
    showCreateNewFromSearchNav() {
      this.syncFloatingState();
    },
  },
  created() {
    if(this.userIsRideManagerOfThisRide){
      this.fetchSerchAttractionsFromRideMangerAcount({
        filters: { rideAttractionPresence: this.managerAttractionPresenceFilter }
      })
    }
    else if(this.compareToUserId( this.allRide.ride.authorId ) &&
            this.isSubdomain &&
            this.isIdIsThisDomainRideManager( this.allRide.ride.ride_manager_id ) ){
      this.fetchSerchAttractionsFromRideMangerAcount()
    }
    else{
      this.fetchSerchAttractionsByRide();
    }
    this.validateAndupdateAppToken();
  },

  updated(){
    if(this.isUserManager || this.isSubdomain){
      return
    }
    this.uplowedGoogleAtractionIfEmpty();
  },
  mounted() {
    registerFloatingItem({
      id: this.floatingId,
      priority: 35,
      anchor: "right",
      zIndex: 999,
    });
    this.syncFloatingState();
  },
  beforeDestroy() {
    unregisterFloatingItem(this.floatingId);
  },

};
</script>

<style scoped>
.add-new-activity-add-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.home[dir="rtl"] .add-new-activity-add-icon p,
.home[dir="ltr"] .add-new-activity-add-icon p {
  width: 100%;
  text-align: center !important;
}

.serch-attraction-media-section {
  border-top: 1px solid #f0f0f0;
  padding-top: 1rem;
  margin-top: 1rem;
}

[dir="rtl"] .serch-attraction-media-section {
  direction: rtl;
  text-align: right;
}

[dir="ltr"] .serch-attraction-media-section {
  direction: ltr;
  text-align: left;
}

[dir="rtl"] .trip-card-footer {
  text-align: right;
}

[dir="ltr"] .trip-card-footer {
  text-align: left;
  padding-left: 0;
  padding-right: 50px;
}

.trip-card-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

[dir="rtl"] .trip-card-footer {
  justify-content: flex-start;
}

[dir="ltr"] .trip-card-footer {
  justify-content: flex-start;
}

.serch-attraction-media-item {
  margin-bottom: 1rem;
}

.serch-attraction-media-item:last-child {
  margin-bottom: 0;
}

.serch-attraction-media-label {
  font-weight: 600;
  font-size: 1.4rem;
  color: #0D2F29;
}

.serch-attraction-media-video {
  width: 100%;
  max-width: 280px;
  max-height: 200px;
  border-radius: 8px;
  background: #000;
}

.serch-attraction-media-audio {
  width: 100%;
  max-width: 280px;
  height: 36px;
}

a.trip-card-btn-voucher {
  background: var(--secondary-background) !important;
  color: white !important;
}

a.trip-card-btn-voucher:hover {
  filter: brightness(0.9);
  color: white !important;
}

.trip-card-footer-voucher {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #f0f0f0;
}

.attractions-list-toggle {
  margin-top: 10px;
  display: inline-flex;
  border: 1px solid #d4d4d4;
  border-radius: 8px;
  overflow: hidden;
}

.toggle-option {
  border: 0;
  background: #fff;
  color: #0D2F29;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
}

.toggle-option.active {
  background: #07A0C3;
  color: #fff;
}

.no-attractions-text {
  color: #666;
  padding: 8px 0 12px;
}
</style>
